/**
 * Banner text added to files that should not be edited by users.
 */
export const NON_EDITABLE_FILE_BANNER =
	"// Code generated by Prismic. DO NOT EDIT.";
